import React from 'react';

// COMPONENTS
import Icon from '../Icon/Icon';

// ENUMS
import { Icons } from '../../enums/icons';

// INTERFACES
import { IHeader } from '../../interfaces/Header.interface';

// STYLES
import { Container, Children, User } from './styles';

const Header: React.FC<IHeader> = ({ children, userName, fixedPosition }: IHeader) => {
  return (
    <Container fixedPosition={fixedPosition}>
      <Children>{children}</Children>
      <User>
        <span>{userName}</span>
        <Icon type={Icons.USER_PROFILE} />
      </User>
    </Container>
  );
};

export default Header;
